// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fsZyA","wrapper":"styles_wrapper__SqIqs","text":"styles_text__Xaft2","icon":"styles_icon__WVr8q"};